const commonParser = require('od-modules/parsers/dynpack_common');
const UNKNOWN_USER_RATE = '0.0';
const MIN_DISCOUNT = 4;
const VALID_USER_RATE = ['TA'];
const VALID_ROOM_ONLY = ['RO'];

function getPriceDiscountData(data) {
    const {price, accommodationDeal, priceBreakdownDynpack} = data;
    return {
        ...commonParser.getPriceDiscountData({
            pricePerPassengerWithoutDiscount: Odigeo._.get(data, 'dynpackFareDiscountDetails.pricePerPassengerWithoutDiscount'),
            discountPercentage: Odigeo._.get(data, 'dynpackFareDiscountDetails.discountPercentage'),
            dynpackFare: accommodationDeal.dynpackFare,
            hasInfoDiscount: false,
            price,
        }),
        ...commonParser.getPrimePriceData(priceBreakdownDynpack),
    };
}

function getPriceInfo(data) {
    const {upsellPriceBreakdown} = data;

    return upsellPriceBreakdown
        ? {
            pricePerPassenger: Odigeo.Utils.splitFormatedCurrency(upsellPriceBreakdown.pricePerPassenger),
            pricePerPassengerWithoutDiscount: Odigeo.Utils.splitFormatedCurrency(upsellPriceBreakdown.pricePerPassengerWithoutDiscount),
            packageDiscountAmountPerPassenger: Odigeo.Utils.splitFormatedCurrency(upsellPriceBreakdown.packageDiscountAmountPerPassenger),
            primeDiscountAmountPerPassenger: Odigeo.Utils.splitFormatedCurrency(upsellPriceBreakdown.primeDiscountAmountPerPassenger),
            discountPercentage: upsellPriceBreakdown.discountPercentage,
        }
        : {};
}

function getUserRateSource(id, {usersRateSource, usersRatePattern}) {
    return !Odigeo._.isUndefined(id) && Odigeo._.includes(VALID_USER_RATE, usersRateSource) && !Odigeo._.isEmpty(usersRatePattern)
        ? (usersRatePattern % 10).toFixed(1)
        : UNKNOWN_USER_RATE;
}

function addTextConfig(data) {
    const textConfig = Odigeo.UIElements.translations.xsellIntermediatePage;

    data.specialDiscount = textConfig.mapDiscounts.specialDiscount;
    data.productMessage = textConfig.mapDiscounts.productMessagePlus;
}

function getTripAdvisorUserRateList(searchReviews, tripAdvisorId) {
    return searchReviews.reduce((userRateList, review) => {
        userRateList.push(getUserRateSource(tripAdvisorId, review));
        return userRateList;
    }, []);
}

function getTripAdvisorUserRate(searchReviews, tripAdvisorId) {
    searchReviews = Odigeo._.filter(searchReviews, (review) => Odigeo._.isEqual(review.source, 'TA'));
    return Odigeo._.last(getTripAdvisorUserRateList(searchReviews, tripAdvisorId));
}

function addAdditionalPriceData(data) {
    let priceParts;
    let currency = Odigeo._.clone(Odigeo.Utils.Currency);

    currency.currencySign = currency.currencySymbolPrefix = '';
    data.fullPrice = data.price;
    priceParts = Odigeo.Utils.formatCurrency(data.price, currency).split(currency.decimalSeparator);
    data.priceInteger = priceParts[0];
    data.priceDecimals = priceParts[1];
}

function addDiscountsData(data) {
    data.originalPrice = Math.floor(Odigeo._.get(data, 'dynpackFareDiscountDetails.pricePerPassengerWithoutDiscount'));
    data.discountPercentage = Math.round(Odigeo._.get(data, 'dynpackFareDiscountDetails.discountPercentage'));
    data.hasDiscountPercentage = data.discountPercentage > MIN_DISCOUNT;
}

function addRoomsLeftData(data) {
    const roomsLeft = data.accommodationDeal.roomsLeft;
    data.hasHotelRoomsLeft = !Odigeo._.isNull(roomsLeft) && roomsLeft >= 1 && roomsLeft <= 4;
}

function getPrimePriceData({priceBreakdownDynpack}) {
    return priceBreakdownDynpack ? commonParser.getPrimePriceData(priceBreakdownDynpack) : null;
}

function getIsPrimeSelected() {
    const flightSelectionData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));
    let isPrimeSelected = false;

    if (flightSelectionData !== null) {
        const {priceWithoutDiscountSelected} = flightSelectionData;
        isPrimeSelected = !priceWithoutDiscountSelected;
    }
    return isPrimeSelected;
}

function getDefaultData(data, absConfig) {
    const {accommodationDeal, accommodationInfo, noHotelPic, numPassengers, nights, price} = data;
    const {imgUrl, category} = accommodationInfo;
    const {accommodationSearchReviews, tripAdvisorId} = accommodationDeal;
    const tripAdvisorUserRate = getTripAdvisorUserRate(accommodationSearchReviews, tripAdvisorId);
    const isPrimeSelected = getIsPrimeSelected();

    return {
        tripAdvisorReview: commonParser.getReviewsData(accommodationSearchReviews),
        nightsText: commonParser.getTextPriceTotal(numPassengers, nights, isPrimeSelected),
        hasTripAdvisorUserRate: !Odigeo._.isUndefined(tripAdvisorUserRate) && parseFloat(tripAdvisorUserRate) !== 0,
        thumbnailUrl: !Odigeo._.isNull(imgUrl) ? imgUrl : noHotelPic,
        category: commonParser.getHotelCategory(category) || {},
        formatPrice: commonParser.getPriceFormat(price),
        isTopChoice: commonParser.isTopChoice(data),
        hookMultitabClass: Odigeo.AB.isDynpackDesktopMultiTab ? 'odf-clickable' : '',
        tripAdvisorUserRate,
        noHotelPic,
        absConfig,
    };
}

function getTooltipSubtemplates(templates) {
    return Odigeo._.pick(templates, 'facilityServices', 'priceDiscount');
}

function hasHotelPreselected(data) {
    return Odigeo._.isEqual(data.preselectedIndex, data.accommodationDeal.key);
}

function getTemplateTooltipData(data, {absConfig, templates}) {
    if (absConfig.hasTooltipTemplate) {
        const {accommodationDeal, accommodationInfo, noHotelPic, offerType} = data;
        const {imgUrl, type} = accommodationInfo;
        const {boardType, roomsLeft} = accommodationDeal;

        const hasBoardType = commonParser.isValidHotelData(boardType);

        return {
            hotelBackgroundImage: commonParser.getBackgroundImageError(imgUrl, noHotelPic),
            templates: getTooltipSubtemplates(templates),
            priceDiscountDynpack: getPriceDiscountData(data),
            hasHotelTypeInfo: commonParser.isValidHotelData(type),
            hasHotelRoomsLeft: commonParser.hasHotelRoomsLeft(roomsLeft),
            hasHotelRoomOnly: Odigeo._.includes(VALID_ROOM_ONLY, boardType),
            hasHotelBoardType: hasBoardType,
            boardTypeIcon: hasBoardType && commonParser.getBoardTypeIcon(boardType),
            hasHotelPreselected: hasHotelPreselected(data),
            priceColorCssModifier: commonParser.getPriceColorCssModifier(roomsLeft),
            isPrimeDaysPromotion: offerType === 'PREMIUM_PRIME' || offerType === 'STANDARD_PRIME',
        };
    }
}

function getTemplateBubbleDiscountsData(data, absConfig) {
    if (absConfig.hasBubbleDiscountsTemplate) {
        addAdditionalPriceData(data);
        addDiscountsData(data);
        addTextConfig(data);
        addRoomsLeftData(data);
    }
}

function getRenderData(data, widget) {
    return Odigeo._.extend({}, data,
        getDefaultData(data, widget.absConfig),
        getTemplateBubbleDiscountsData(data, widget.absConfig),
        getTemplateTooltipData(data, widget),
        getPrimePriceData(data),
        {priceInfo: getPriceInfo(data)},
    );
}

module.exports = {
    getRenderData,
};
